import SlaRules from './SlaRules';

export default SlaRules;
